<div class="dialog">
    <div class="modal-header">
        <img class="modal-close" (click)="close()" alt="" />
    </div>
    <div class="modal-body">
        <div *ngIf="!suspended">
            <img class="modal-body__image mt-4" src="../../assets/icons/purchase/inactivity-clock.png" alt="" />
            <div>
                <div class="modal-body__message mt-4 mb-4">
                    Due to inactivity this purchase will be auto suspended in the next:
                </div>
                <div *ngIf="showTime" class="modal-body__message mt-4 mb-4 timer">
                    {{ time }}
                </div>
                <div class="modal-body__message mt-4">
                    You can stop this action by clicking the
                    ‘I’m Here’ button below. If a period
                    of inactivity of {{minutesBeforeAutoSuspend}} minutes is detected,
                    we will auto suspend the purchase.
                </div>

                <br>
            </div>
        </div>

        <div *ngIf="suspended">
            <img class="modal-body__image mt-4" src="../../assets/icons/purchase/inactivity-clock-red.png" alt="" />
            <div>
                <div class="modal-body__message mt-4">
                    Due to inactivity your purchase was auto suspended. You can resume
                    the purchase by clicking on the
                    appointment on the diary.
                </div>
            </div>
        </div>

    </div>
    <div class="footer">
        <button type="button" class="modal-body__button button_green" (click)="close()">
            {{ suspended ? 'Ok' : "I'm Here!" }}
        </button>
    </div>
</div>